function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import SimpleBar from 'simplebar-react';
const notificationContainerStyle = {
  maxHeight: '230px',
  display: 'none'
};
const notificationShowContainerStyle = {
  maxHeight: '230px'
};

class NotificationDropdown extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "getRedirectUrl", item => {
      return `/notification/${item.id}`;
    });

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false,
      notificationContainerStyle: notificationContainerStyle
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      notificationContainerStyle: this.state.notificationContainerStyle === notificationContainerStyle ? notificationShowContainerStyle : notificationContainerStyle
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      "data-toggle": "dropdown",
      tag: "button",
      className: "nav-link dropdown-toggle arrow-none btn btn-link",
      onClick: this.toggleDropdown,
      "aria-expanded": this.state.dropdownOpen
    }, /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-bell-outline noti-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "noti-icon-badge"
    })), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated dropdown-lg"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.toggleDropdown
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-item noti-title"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "m-0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "float-right"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/notifications",
      className: "text-dark"
    }, /*#__PURE__*/React.createElement("small", null, "Clear All"))), "Notification")), /*#__PURE__*/React.createElement(SimpleBar, {
      style: this.state.notificationContainerStyle
    }, this.props.notifications.map((item, i) => {
      return /*#__PURE__*/React.createElement(Link, {
        to: this.getRedirectUrl(item),
        className: "dropdown-item notify-item",
        key: i + '-noti'
      }, /*#__PURE__*/React.createElement("div", {
        className: `notify-icon bg-${item.bgColor}`
      }, /*#__PURE__*/React.createElement("i", {
        className: item.icon
      })), /*#__PURE__*/React.createElement("p", {
        className: "notify-details"
      }, item.text, /*#__PURE__*/React.createElement("small", {
        className: "text-muted"
      }, item.subText)));
    })), /*#__PURE__*/React.createElement(Link, {
      to: "/",
      className: "dropdown-item text-center text-primary notify-item notify-all"
    }, "View All"))));
  }

}

_defineProperty(NotificationDropdown, "defaultProps", {
  notifications: []
});

export default NotificationDropdown;